import { AlarmSnoozeIcon } from './AlarmSnoozeIcon';

/**
 * author: Google
 * id 28F85724-265B-4C24-9975-DDDF788A99E5
 * name alarm-snooze
 * version: 1.7.12
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/alarm-snooze.svg
 * tags
 * - Date / Time 
 */
export const AlarmClockSnoozeIcon = AlarmSnoozeIcon;
export default AlarmClockSnoozeIcon